import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Css
// import "./artifacts/css/util.css";
import "./artifacts/css/main.css";
// import "./artifacts/css/spinner.css";
// import "./artifacts/css/login.css";

import defaultImage from "./artifacts/images/bg-01.jpg";
import movyx from "../../assets/MovyxSafe.png";
import { useTheme } from "../../contexts/NewThemeContext";

// Components
import Access from "./Access/Access";
import Remember from "./Remember/Remember";
import Reset from "./Reset/Reset";
import ModalDefault from "../Components/Modals/index";
import Spinner from "../Components/Spinner";

//BiMessageRounded
import { BsFillTelephoneFill } from "react-icons/bs";
import { BiMessageRounded } from "react-icons/bi";

export default function Login() {
  const { companyLogo, companyMainImageUrl, centralPhone, companyPhone, phrase, androidLink, iosLink } = useTheme();
  const { t } = useTranslation();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [showConfigModal] = useState(false);
  const [showAccess, setShowAccess] = useState(false);
  const [mainImage, setMainImage] = useState("");
  const [showReset, setShowReset] = useState(false);

  const showAccessSection = (show) => {
    setShowAccess(show); // eslint-disable-next-line
  };

  useEffect(() => {
    const initialize = async () => {
      setMainImage(companyMainImageUrl);
    };
    initialize();
  }, [companyMainImageUrl]);

  // useEffect(() => {
  //   if(location.pathname == "/") {
  //     setShowReset(false)
  //     setShowAccess(true)
  //   } else {
  //     setShowReset(true)
  //     setShowAccess(false)
  //   }
  // }, [location])

  useEffect(() => {
    const hasAutoLoginParams =
      window.location.href.includes("p1=") &&
      window.location.href.includes("p2=");
    const isReset = location.pathname.startsWith("/resetpass");

    if (hasAutoLoginParams) {
      setShowAccess(true);
      setShowReset(false);
    } else if (isReset) {
      setShowAccess(false);
      setShowReset(true);
    } else {
      setShowAccess(true);
      setShowReset(false);
    }
  }, [location]);

  return (
    <>
      <ModalDefault
        message={t("ERRORS.CONFIG_NOT_FOUND")}
        closeButton={"OK"}
        show={showConfigModal}
        backdrop={"static"}
        size={"lg"}
      />

      <div className="limiter">
        <div className="container-login100">
          <div className="wrap-login100">
            <form className="login100-form validate-form">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "30px",
                  paddingTop: "15px",
                }}
                onClick={() => { }}
              >
                <img height={100} src={companyLogo} alt="movyx-logo" style={{ maxWidth: "100%" }} />
              </div>

              {loading ? (
                <>
                  <h3 className="showMessage">{t("LOGIN.LOADING_SETTINGS")}</h3>
                  <Spinner />
                </>
              ) : showAccess ? (
                <>
                  <Access
                    showAccessSection={showAccessSection}
                    onLoading={(display) => setLoading(display)}
                  />

                  <div className="card" style={{ marginTop: "30px", backgroundColor: "white" }}>
                    <div className="card-body">
                      <h5 className="card-title" style={{ color: "#000" }}>{t("LOGIN.CONTACTS")}</h5>
                      <p className="card-text">
                        <a
                          target="_blank"
                          href={"tel: (12)3570-1100"}
                          rel="noopener noreferrer"
                        >
                          {companyPhone || ""}
                          <BsFillTelephoneFill
                            style={{
                              marginLeft: "10px",
                              fontSize: "15px",
                            }}
                          />
                        </a>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={
                            "https://api.whatsapp.com/send/?phone=55" +
                            (companyPhone || "").replace(/[^a-zA-Z0-9 ]/g, "")
                          }
                        >
                          <BiMessageRounded
                            style={{
                              marginLeft: "10px",
                              fontSize: "15px",
                              color: "#54CC60",
                            }}
                          />
                        </a>
                      </p>
                      <p className="card-text">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={"tel: " + (centralPhone || "")}
                        >
                          {centralPhone || ""}
                          <BsFillTelephoneFill
                            style={{
                              marginLeft: "10px",
                              fontSize: "15px",
                            }}
                          />{" "}
                          {/** eslint-disable-next-line */}
                        </a>
                      </p>

                      <p className="card-text">{phrase}</p>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "10px", marginTop: "20px", justifyContent: "center" }}>
                    <a href={iosLink ?? process.env.REACT_APP_LINK_DOWNLOAD_IOS} target="_blank" rel="noopener noreferrer">
                      <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download na App Store" style={{ height: "40px" }} />
                    </a>
                    <a href={androidLink ?? process.env.REACT_APP_LINK_DOWNLOAD_ANDROID} target="_blank" rel="noopener noreferrer">
                      <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Disponível no Google Play" style={{ height: "40px" }} />
                    </a>
                  </div>
                </>
              ) : showReset ? (
                <Reset onLoading={(display) => setLoading(display)} />
              ) : (
                <Remember
                  showAccessSection={showAccessSection}
                  /** eslint-disable-next-line */
                  onLoading={(display) => setLoading(display)}
                />
              )}
            </form>

            <div
              className="login100-more"
              style={{
                backgroundImage: `url("${process.env.PUBLIC_URL + mainImage}")`,
              }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
}